<template>
  <div>
    <section class="analysis" @click="link('hrv')">
      <div class="title">
        <div class="hd" :style="{color:hrv.color}">
          <i class="iconfont icon-HRV" />
          HRV心脏指数
        </div>
        <!-- <div class="bd">
          {{ hrv.time[hrv.time.length-1] }}
        </div> -->
      </div>
      <div id="hrv" class="content" />
      <div v-if="!hrv.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <section class="analysis" @click="link('pause')">
      <div class="title">
        <div class="hd" :style="{color:pause.color}">
          <i class="iconfont icon-shuimian icon-red" />
          呼吸暂停次数
        </div>
        <!-- <div class="bd">
          {{ pause.time[pause.time.length-1] }}
        </div> -->
      </div>
      <div id="pause" class="content" />
      <div v-if="!pause.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <section class="analysis" @click="link('bp')">
      <div class="title">
        <div class="hd" style="color: #FCA251">
          <i class="iconfont icon-xueya" />
          血压
        </div>
        <!-- <div class="bd">
          {{ bp.time[bp.time.length-1] }}
        </div> -->
      </div>
      <div id="bp" class="content" />
      <div v-if="!bp.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <section class="analysis" @click="link('bs')">
      <div class="title">
        <div class="hd" style="color: #30C37F">
          <i class="iconfont icon-xuetang" />
          血糖
        </div>
        <!-- <div class="bd">
          {{ bs.time[bs.time.length-1] }}
        </div> -->
      </div>
      <div id="bs" class="content" />
      <div v-if="!bs.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <section class="analysis" @click="link('hb')">
      <div class="title">
        <div class="hd" style="color: #39AAFF">
          <i class="iconfont icon-xinshuai" />
          心率
        </div>
        <!-- <div class="bd">
          {{ hb.time[hb.time.length-1] }}
        </div> -->
      </div>
      <div id="hb" class="content" />
      <div v-if="!hb.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <!-- <section class="analysis" @click="link('hbt')">
      <div class="title">
        <div class="hd" style="color: #98F7FD">
          <i class="iconfont icon-xinlv" />
          心电
        </div>
        <div class="bd">
          {{ hbt.time[0] }}
        </div>
      </div>
      <div id="hbt" class="content" />
      <div v-if="!hbt.xData.length" class="empty">{{$t('viewBase.a47')}}</div>
    </section> -->

    <section class="analysis" @click="link('hld')">
      <div class="title">
        <div class="hd" style="color: #8164EE">
          <i class="iconfont icon-yali" />
          心脏负荷
        </div>
        <!-- <div class="bd">
          {{ hld.time[hld.time.length-1] }}
        </div> -->
      </div>
      <div id="hld" class="content" />
      <div v-if="!hld.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <section class="analysis" @click="link('bo')">
      <div class="title">
        <div class="hd" style="color: #5799F1">
          <i class="iconfont icon-xueyang" />
          血氧
        </div>
        <!-- <div class="bd">
          {{ bo.time[bo.time.length-1] }}
        </div> -->
      </div>
      <div id="bo" class="content" />
      <div v-if="!bo.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <section class="analysis" @click="link('as')">
      <div class="title">
        <div class="hd" style="color: #ED6A68">
          <i class="iconfont icon-icondmyh" />
          动脉硬化指数
        </div>
        <!-- <div class="bd">
          {{ as.time[as.time.length-1] }}
        </div> -->
      </div>
      <div id="as" class="content" />
      <div v-if="!as.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>

    <!-- <section class="analysis" @click="link('bmi')">
      <div class="title">
        <div class="hd" style="color: #E37FEF">
          <i class="iconfont icon-bmi" />
          BMI
        </div>
        <div class="bd">
          {{ bmi.time[0] }}
        </div>
      </div>
      <div id="bmi" class="content" />
      <div v-if="!bmi.xData.length" class="empty">{{$t('viewBase.a47')}}</div>
    </section> -->

    <section class="analysis" @click="link('step')">
      <div class="title">
        <div class="hd" style="color: #FCA251">
          <i class="iconfont icon-paobu" />
          运动
        </div>
        <!-- <div class="bd">
          {{ step.time[step.time.length-1] }}
        </div> -->
      </div>
      <div id="step" class="content" />
      <div v-if="!step.xData.length" class="empty">{{ $t('viewBase.a47') }}</div>
    </section>
  </div>
</template>

<script>
import { fetchHealths } from '@/api/health'
import { dateFormat, dateISO } from '@/utils/tool'

var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/dataZoom')

export default {
  data() {
    return {
      bp: {
        dom: 'bp', // 血压
        color: '#FCA251',
        xData: [],
        Ydata: [],
        YData: [],
        time: []
      },
      bs: {
        dom: 'bs',
        color: '#31C37F',
        xData: [],
        Ydata: [],
        time: []
      },
      hb: {
        dom: 'hb',
        color: '#E37FEF',
        xData: [],
        Ydata: [],
        time: []
      },
      bo: {
        dom: 'bo',
        color: '#39AAFF',
        xData: [],
        Ydata: [],
        time: []
      },
      step: {
        dom: 'step',
        color: '#FCA251',
        xData: [],
        Ydata: [],
        time: []
      },
      pause: {
        dom: 'pause',
        color: '#D9220C',
        xData: [],
        Ydata: [],
        time: []
      },
      hrv: {
        dom: 'hrv',
        color: '#E37FEF',
        xData: [],
        Ydata: [],
        time: []
      },
      hbt: {
        dom: 'hbt',
        color: '#39AAFF',
        xData: [],
        Ydata: [],
        time: []
      },
      hld: {
        dom: 'hld',
        color: '#8164EE',
        xData: [],
        Ydata: [],
        time: []
      },
      as: {
        dom: 'as',
        color: '#ED6A68',
        xData: [],
        YData: [],
        Ydata: [],
        time: []
      },
      bmi: {
        dom: 'bmi',
        color: '#A85AB9',
        xData: [],
        Ydata: [],
        time: []
      }
    }
  },
  created() {
    const date = new Date()
    date.setDate(date.getDate() - 30)
    fetchHealths({
      sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
      eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
      order: 1
    }).then(res => {
      const data = res.data.data
      // data.sleepActivityList.forEach(item => {
      //   this.pause.xData.push(dateFormat(item.testTime, 'M-D'))
      //   this.pause.Ydata.push(item.breathPause)
      //   this.pause.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      // })
      data.apneaList.forEach(item => {
        this.pause.xData.push(dateFormat(item.testTime, 'M-D'))
        this.pause.Ydata.push(item.apneaCount)
        this.pause.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.pause)

      data.hrvAvgList.forEach(item => {
        this.hrv.xData.push(dateFormat(item.testTime, 'M-D'))
        this.hrv.Ydata.push(item.hrvIndex)
        this.hrv.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.hrv)

      data.bloodPressureList.forEach(item => {
        this.bp.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bp.Ydata.push(item.sbp)
        this.bp.YData.push(item.dbp)
        this.bp.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.bp)

      data.bloodSugarList.forEach(item => {
        this.bs.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bs.Ydata.push(item.bs)
        this.bs.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.bs)

      data.heartBeatList.forEach(item => {
        this.hb.xData.push(dateFormat(item.testTime, 'M-D'))
        this.hb.Ydata.push(item.hb)
        this.hb.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.hb)

      data.bloodOxygenList.forEach(item => {
        this.bo.xData.push(dateFormat(item.testTime, 'M-D'))
        this.bo.Ydata.push(item.bo)
        this.bo.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.bo)

      data.walkStepList.forEach(item => {
        this.step.xData.push(dateFormat(item.testTime, 'M-D'))
        this.step.Ydata.push(item.step)
        this.step.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.step)
      // data.sleepActivityList.forEach(item => {
      //   this.hld.xData.push(dateFormat(item.testTime, 'M-D'))
      //   this.hld.Ydata.push(item.heartLoad)
      //   this.hld.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      // })
      data.heartLoadDailyList.forEach(item => {
        this.hld.xData.push(dateFormat(item.testTime, 'M-D'))
        this.hld.Ydata.push(item.heartLoadAvg)
        this.hld.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
      })
      this.chart(this.hld)
      if (data.arteriosclerosis[0]) {
        if (data.arteriosclerosis[0].asi > 0) {
          const listAsi = data.arteriosclerosis.filter(item => {
            return item.asi > 0
          })
          listAsi.forEach(item => {
            this.as.Ydata.push(item.asi)
            this.as.xData.push(dateFormat(item.testTime, 'M-D'))
            this.as.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
          })
        } else {
          const listApi = data.arteriosclerosis.filter(item => {
            return item.api > 0 && item.avi > 0
          })
          listApi.forEach(item => {
            this.as.YData.push(item.api)
            this.as.Ydata.push(item.avi)
            this.as.xData.push(dateFormat(item.testTime, 'M-D'))
            this.as.time.push(dateFormat(item.testTime, 'MM-DD hh:mm'))
          })
        }
      }
      this.chart(this.as)
    })
  },
  mounted() {
  },
  methods: {
    chart(data) {
      var myChart = echarts.init(document.getElementById(data.dom))
      const series = [{
        data: data.Ydata,
        type: 'line',
        // smooth: true,
        lineStyle: {
          color: data.color
        },
        itemStyle: {
          color: data.color
        }
      }]
      if (data.dom === 'bp' || data.dom === 'as') {
        series.push({
          data: data.YData,
          type: 'line',
          // smooth: true,
          lineStyle: {
            color: '#E37FEF'
          },
          itemStyle: {
            color: '#E37FEF'
          }
        })
      }
      myChart.setOption({
        grid: {
          left: '4%', // 图表距边框的距离
          right: '4%',
          top: '5%',
          bottom: '7%',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          moveOnMouseMove: true,
          zoomLock: true,
          startValue: data.xData.length > 7 ? data.xData[data.xData.length - 7] : data.xData[0],
          endValue: data.xData[data.xData.length - 1]
        }],
        xAxis: {
          type: 'category',
          data: data.xData,
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisLabel: {
            color: '#333'
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#333'
          }
        },
        series
      }, true)
    },
    link(item) {
      this.$router.push(`/health/${item}`)
    }
  }
}
</script>

<style scoped lang="scss">
  .iconfont {
    background: #FCA251;
    border: 3px solid #FCA251;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
  }
  .icon-xuetang {
    background: #30C37F;
    border-color: #30C37F;
  }
  .icon-HRV {
    background: #E37FEF;
    border-color: #E37FEF;
  }
  .icon-xinlv {
    background: #98F7FD;
    border-color: #98F7FD;
  }
  .icon-yali{
   background: #8164EE;
   border-color: #8164EE;
  }
  .icon-xinshuai {
    background: #39AAFF;
    border-color:#39AAFF;
  }
  .icon-icondmyh{
    background:#ED6A68;
     border-color:#ED6A68;
  }
  .icon-xueyang {
    background: #5799F1;
    border-color:#5799F1;
  }
  .icon-bmi{
    background: #A85AB9;
    border-color:#A85AB9;
  }
  .icon-red{
    background: #D9220C;
    border-color:#D9220C;
  }
  .time {
    background: #fff;
  }
  .analysis {
    background: #fff;
    margin-bottom: 10px;
    border-bottom: 1px solid #ececec;
    position: relative;
    .empty {
      text-align: center;
      color: #999;
      font-size: 12px;
      width: 100%;
      position: absolute;
      top: 45%;
    }
    .title {
      font-size: 14px;
      color: #999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
    }
    .bd {
      font-size: 12px;
    }
    .content {
      height: 180px;
      background: #fff;
      border-radius: 5px;
    }
  }
</style>
